"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextoPadrao;
(function (TextoPadrao) {
    TextoPadrao["CinzaMU600"] = "#646363";
    TextoPadrao["PretoMU900"] = "#001729";
})(TextoPadrao || (TextoPadrao = {}));
exports.default = TextoPadrao;
